import React from 'react';
import PropTypes from 'prop-types';
import {
  FormGroup,
  ControlLabel,
  HelpBlock,
  Alert,
  Checkbox
} from 'react-bootstrap';
import Tags from 'react-tag-autocomplete';
import questionTypes from '../questionTypes.json';
import './styles.css';

MultipleAnswerQuestionCombo.propTypes = {
  questionId: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  options: PropTypes.array.isRequired,
  answers: PropTypes.array.isRequired,
  onAnswer: PropTypes.func,
  readOnly: PropTypes.bool,
  showValidation: PropTypes.bool,
  validationState: PropTypes.string,
  help: PropTypes.string,
  placeHolder: PropTypes.string
};

function MultipleAnswerQuestionCombo({
  questionId,
  text,
  options,
  onAnswer,
  answers,
  readOnly,
  showValidation,
  validationState = null,
  help,
  placeHolder
}) {
  const selectedAnswersIds = answers.map(answer => answer.answerId);

  let selectedAnswers = options.filter(item => {
    return selectedAnswersIds.indexOf(item.answerId) >= 0;
  });

  let unSelectedAnswers = options.filter(item => {
    return selectedAnswersIds.indexOf(item.answerId) < 0;
  });

  return (
    <FormGroup validationState={showValidation ? validationState : null}>
      <ControlLabel>{text}</ControlLabel>
      {!readOnly && (
        <Tags
          minQueryLength={1}
          maxSuggestionsLength={15}
          className={'react-tags'}
          placeholder={placeHolder}
          tags={selectedAnswers.map(option => ({
            id: option.answerId,
            name: option.text
          }))}
          suggestions={unSelectedAnswers.map(option => ({
            id: option.answerId,
            name: option.text
          }))}
          handleDelete={index =>
            selectedAnswers[index]
              ? onAnswer(
                questionId,
                questionTypes.multipleAnswerCombo,
                selectedAnswers[index].answerId
              )
              : null}
          handleAddition={answer =>
            onAnswer(questionId, questionTypes.multipleAnswerCombo, answer.id)}
        />
      )}

      <hr />

      {readOnly &&
        options.map((option, index) => (
          <Checkbox
            readOnly
            key={index}
            name={questionId}
            disabled={readOnly}
            onClick={() => {
              onAnswer(
                questionId,
                questionTypes.multipleAnswerCombo,
                option.answerId
              );
            }}
            checked={selectedAnswersIds.indexOf(option.answerId) > -1}
          >
            {option.text}
          </Checkbox>
        ))}

      {help &&
        showValidation && (
          <HelpBlock>
            <Alert bsStyle="danger">{help}</Alert>
          </HelpBlock>
        )}
    </FormGroup>
  );
}

export default MultipleAnswerQuestionCombo;



// WEBPACK FOOTER //
// ./src/components/questions/MultipleAnswerComboQuestion/MultipleAnswerQuestionCombo.js